import { render, staticRenderFns } from "./ReplyV2.vue?vue&type=template&id=6a0dde42&"
import script from "./ReplyV2.vue?vue&type=script&lang=js&"
export * from "./ReplyV2.vue?vue&type=script&lang=js&"
import style0 from "./ReplyV2.vue?vue&type=style&index=0&id=6a0dde42&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports